import type { LiveUpdate } from '@/types/content';

export const liveUpdates: LiveUpdate[] = [
  { id: 'l-1', time: '刚刚', text: '某偶像团体巡演临时调整场次安排，主办方发布说明', topicId: 'tour-schedule-change' },
  { id: 'l-2', time: '3 分钟前', text: '热播剧大结局口碑两极，观众讨论集中在人物结局处理', topicId: 'finale-reaction' },
  { id: 'l-3', time: '12 分钟前', text: '综艺新赛制公布，嘉宾分组方式引发广泛讨论', topicId: 'variety-new-rule' },
  { id: 'l-4', time: '25 分钟前', text: '知名主播就直播争议公开回应，公布完整录像时间线', topicId: 'streamer-response' },
  { id: 'l-5', time: '41 分钟前', text: '影视项目换角消息落地，制作方回应档期原因', topicId: 'casting-shift' },
  { id: 'l-6', time: '1 小时前', text: '两家经纪公司就艺名归属发布联合声明', topicId: 'agency-joint-statement' },
  { id: 'l-7', time: '2 小时前', text: '音乐节阵容公布，首日票务页面一度拥堵', topicId: 'music-festival-lineup' },
  { id: 'l-8', time: '3 小时前', text: '短视频平台调整流量规则，创作者群体反应不一', topicId: 'traffic-rule-update' },
];